import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "react-redux";
import socket from "../../assets/socketConnection";
import { createStructuredSelector } from "reselect";
import ArrowDownIcon from "../../assets/img/arrowDownIcon";
import Bookmark from "../../assets/img/bookmark";
import { v4 as uuidv4 } from "uuid";
import LoadingText from "../../components/loadingText/loadingText.component";
import {
  setGoLevel4,
  setMapLevel,
  setSourceLocationJustSet,
  toggleMapOverlayLeftShow,
} from "../../redux/map/map.actions";
import {
  selectCenterOfMap,
  selectCenterOfMapAddressIsLoading,
  selectMapCenterOfMapAddress,
  selectMapLeftOverlayShow,
  selectMapLevel,
} from "../../redux/map/map.selectors";
import {
  setNewRequestSourceLocation,
  setNewRequestDestinationLocation,
  setNewRequestOtherDestinationsLocation,
  setNewRequestSelectionLevel,
  fetchNewRequestVehiclesAsync,
  setLoadingDescription,
  setEvacuationDescription,
} from "../../redux/newRequest/newRequest.actions";
import {
  selectNewRequestSelectionLevel,
  selectNewRequestOtherDestinationsLocation,
  selectLoadingDescription,
  selectEvacuationDescription,
} from "../../redux/newRequest/newRequest.selectors";
import MapLeftOverlay from "../mapLeftOverlay/mapLeftOverlay.component";
import { MapCaptionStyled } from "./mapCaption.styles";

const MapCaption = ({
  selectMapLevel,
  selectMapCenterOfMapAddress,
  selectCenterOfMapAddressIsLoading,

  selectMapLeftOverlayShow,

  toggleMapOverlayLeftShow,
  setNewRequestSourceLocation,
  setNewRequestDestinationLocation,
  selectNewRequestOtherDestinationsLocation,
  setMapLevel,

  selectCenterOfMap,

  setNewRequestSelectionLevel,
  fetchNewRequestVehiclesAsync,
  selectNewRequestSelectionLevel,
  setGoLevel4,
  setSourceLocationJustSet,
  setNewRequestOtherDestinationsLocation,
}) => {
  const { ostan, shahr, address } = selectMapCenterOfMapAddress;
  const show_mapOverlayLeft = () => () => {
    // alert("hi");
    toggleMapOverlayLeftShow(true);
  };

  const handle_mapSubBtn_click = () => () => {
    // alert("hid");
    const { ostan_id, shahr_id, address, ostan, shahr } =
      selectMapCenterOfMapAddress;
    console.log(selectMapCenterOfMapAddress);
    // debugger;
    const { lat, lng } = selectCenterOfMap;
    // debugger;
    if (selectMapLevel === 0) {
      const obj = {
        // source_address_id: "",
        detail: address,
        lat,
        long: lng,
        ostan: ostan_id,
        shahr: shahr_id,

        ostan_name: ostan,
        shahr_name: shahr,
      };
      setNewRequestSourceLocation(obj);
      // debugger;
      setSourceLocationJustSet(true);
      setMapLevel(1);
    } else if (selectMapLevel === 1) {
      const obj = {
        // destination_address_id: "",
        detail: address,
        lat,
        long: lng,
        ostan: ostan_id,
        shahr: shahr_id,

        ostan_name: ostan,
        shahr_name: shahr,
      };
      setNewRequestDestinationLocation(obj);
      fetchNewRequestVehiclesAsync(socket);
      // drawLine();
      setMapLevel(2);
      setGoLevel4(true);
    } else if (selectMapLevel > 1 && selectMapLevel < 2) {
      const obj = {
        destination_address_id: uuidv4(),
        detail: address,
        lat,
        long: lng,
        ostan: ostan_id,
        shahr: shahr_id,
        ostan_name: ostan,
        shahr_name: shahr,
      };
      console.log("lala", selectNewRequestOtherDestinationsLocation);
      setNewRequestOtherDestinationsLocation(obj);
      fetchNewRequestVehiclesAsync(socket);
      // drawLine();
      setMapLevel(2);
      setGoLevel4(true);
    }
  };
  console.log(selectCenterOfMapAddressIsLoading);
  const loadingDescription = useSelector(selectLoadingDescription);
  const evacuationDescription = useSelector(selectEvacuationDescription);
  const dispatch = useDispatch();
  const handle_Ldesc_change = (e) => {
    const value = e.currentTarget.value;
    dispatch(setLoadingDescription(value));
  };
  const handle_Edesc_change = (e) => {
    const value = e.currentTarget.value;
    dispatch(setEvacuationDescription(value));
  };
  return (
    <>
      <MapCaptionStyled
        selectMapLeftOverlayShow={selectMapLeftOverlayShow}
        selectMapLevel={selectMapLevel}
      >
        <div className="position-relative d-flex flex-column justify-content-end">
          <button
            className="map-caption__white mb-2 position-relative"
            onClick={() => {
              setNewRequestSelectionLevel(0);
              show_mapOverlayLeft()();
            }}
          >
            {!selectCenterOfMapAddressIsLoading ? (
              <>
                {selectMapCenterOfMapAddress
                  ? ` استان : ${ostan}`
                  : "استان خود را انتخاب  کنید!"}
                <ArrowDownIcon size="18" />
              </>
            ) : (
              <LoadingText className="flex-grow-1" />
            )}
          </button>
          <button
            className="map-caption__white mb-2 position-relative"
            onClick={() => {
              if (selectNewRequestSelectionLevel === 3)
                setNewRequestSelectionLevel(0);
              // else setNewRequestSelectionLevel(1);

              show_mapOverlayLeft()();
            }}
          >
            {!selectCenterOfMapAddressIsLoading ? (
              <>
                {selectMapCenterOfMapAddress
                  ? ` شهر : ${shahr}`
                  : "شهر خود را انتخاب کنید!"}
                <ArrowDownIcon size="18" />
              </>
            ) : (
              <LoadingText className="flex-grow-1" />
            )}
          </button>
          <div className="map-caption__white mb-2">
            {!selectCenterOfMapAddressIsLoading ? (
              selectMapCenterOfMapAddress ? (
                address
              ) : (
                "آدرس خود را انتخاب کنید!"
              )
            ) : (
              <LoadingText className="flex-grow-1" />
            )}
          </div>

          <MapLeftOverlay dataType={1} show={selectMapLeftOverlayShow} />
          {selectMapLevel === 0 ? (
            <input
              type="text"
              className="map-caption__white"
              placeholder="توضیحات بارگیری"
              onChange={handle_Ldesc_change}
              value={loadingDescription}
            />
          ) : (
            <input
              type="text"
              className="map-caption__white"
              placeholder="توضیحات تخلیه"
              onChange={handle_Edesc_change}
              value={evacuationDescription}
            />
          )}
        </div>
        <div>
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ height: 36 }}
          >
            <button className="map-caption__myAdrs-btn">
              <Bookmark width="24" height="24" />
            </button>
            {!selectCenterOfMapAddressIsLoading ? (
              <button
                className="map-caption__sub-btn font-weight-bold font-size--3 text-white"
                onClick={handle_mapSubBtn_click()}
              >
                {selectMapLevel === 0 ? "ثبت مبدا" : "ثبت مقصد"}
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </MapCaptionStyled>
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  selectMapLevel: selectMapLevel,
  selectMapCenterOfMapAddress: selectMapCenterOfMapAddress,
  selectCenterOfMapAddressIsLoading: selectCenterOfMapAddressIsLoading,

  selectMapLeftOverlayShow: selectMapLeftOverlayShow,

  selectCenterOfMap: selectCenterOfMap,

  selectNewRequestSelectionLevel: selectNewRequestSelectionLevel,
  selectNewRequestOtherDestinationsLocation:
    selectNewRequestOtherDestinationsLocation,
});

const mapDispatchToProps = (dispatch) => ({
  fetchNewRequestVehiclesAsync: (x) =>
    dispatch(fetchNewRequestVehiclesAsync(x)),
  toggleMapOverlayLeftShow: (x) => dispatch(toggleMapOverlayLeftShow(x)),

  setNewRequestSourceLocation: (x) => dispatch(setNewRequestSourceLocation(x)),
  setNewRequestDestinationLocation: (x) =>
    dispatch(setNewRequestDestinationLocation(x)),

  setMapLevel: (x) => dispatch(setMapLevel(x)),

  setNewRequestSelectionLevel: (x) => dispatch(setNewRequestSelectionLevel(x)),
  setGoLevel4: (x) => dispatch(setGoLevel4(x)),

  setSourceLocationJustSet: (x) => dispatch(setSourceLocationJustSet(x)),
  setNewRequestOtherDestinationsLocation: (x) =>
    dispatch(setNewRequestOtherDestinationsLocation(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapCaption);
